<template>
  <div id="Bidding" class="Bidding-container" v-if="coinDefault">
    <vs-row class="trade-info">
      <div class="coin-sel">
        <!-- MARKET SELECT//S -->
        <span
          class="coin-name"
          :class="{ active: coinsel }"
          @click="coinsel = !coinsel"
          >{{ coinDefault.text }}</span
        >
        <transition name="slide-fade">
          <div v-if="coinsel" class="coin-sel">
            <vs-tabs :value="marketActive">
              <vs-tab
                :label="`${$bnCode(code)}`"
                v-for="(marketList, code) in markets"
                :key="code"
              >
                <!-- KRW TAB//S -->
                <ul
                  class="coin-list coinlist"
                  :class="{ loadActive: loadList, loadEnd: loadEnd }"
                >
                  <template v-if="marketList.length">
                    <li
                      v-for="(market, index) in marketList"
                      :key="index"
                      :class="{ active: market.active }"
                    >
                      <router-link
                        :to="
                          `/trade/${market.baseCoinCode}/${market.dealCoinCode}`
                        "
                        class="default"
                      >
                        <div
                          class="market-item-list"
                          @click="coinsel = !coinsel"
                        >
                          <h4
                            class="coin-name pull-left"
                            v-if="market.dealCoinInfo"
                          >
                            <img :src="market.img" alt />
                            {{ market.dealCoinInfo.name }} ({{
                              $bnCode(market.dealCoinCode)
                            }})
                          </h4>
                          <div class="current-price text-right">
                            <i
                              class="material-icons icon-final"
                              :class="market.perc | rbClass"
                            >
                              {{ market.perc | caret }}
                            </i>
                            <span :class="market.perc | rbClass">
                              {{ market.percStr }} ({{ market.diff }})
                            </span>
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </template>
                  <template v-else>
                    <template v-if="$bnCode(code) === 'KRW'">
                      <img
                        width="100%"
                        src="../../assets/img/main/img_krw_close.png?v=1.3"
                      />
                    </template>
                    <template v-else>
                      <img
                        v-if="Server.version > 2"
                        width="100%"
                        src="../../assets/img/main/img_coin_close.jpg?v=1.3"
                      />
                      <img
                        v-else
                        width="100%"
                        src="../../assets/img/main/pair_market_disable.jpg?v=1.2"
                      />
                    </template>
                  </template>
                </ul>
                <!-- KRW TAB//E -->
              </vs-tab>
            </vs-tabs>
          </div>
        </transition>
        <!-- MARKET SELECT//E -->
      </div>
      <div>
        <!-- CURRENT PRICE//S -->
        <div class="current-price text-right">
          <h3>{{ autoFormat(actMarket.close) }}</h3>
          <i class="material-icons icon-final">{{ actMarket.diff | caret }}</i>
          <span :class="actMarket.perc | rbClass">
            {{ actMarket.percAbs }} ({{ autoFormat(actMarket.diffStr) }})
          </span>
        </div>
        <!-- CURRENT PRICE//E -->
      </div>
    </vs-row>
    <!-- TABS//S -->
    <div class="tab-design trade">
      <ul>
        <li>
          <router-link class="en-small" :to="{ name: 'TradeWithCode' }">
            {{ $t("trade.orderBook.transaction") }}
          </router-link>
        </li>
        <li>
          <router-link class="en-small" to>
            {{ $t("trade.orderBook.askingPrice") }}
          </router-link>
        </li>
        <li>
          <router-link class="en-small" :to="{ name: 'ChartWithCode' }">
            {{ $t("trade.chart") }}
          </router-link>
        </li>
      </ul>
    </div>
    <!-- TABS//E -->
    <!-- 호가//S -->
    <div class="orderbook-wrap">
      <!-- 표시잔량 합계//E-->
      <div class="Bidding-container__total-box">
        <div class="Bidding-container__sell">
          <div
            class="graph"
            :style="{
              width: `${calcVolumePerc(actMarket.askSum)}%`,
            }"
          ></div>
          <span>
            {{ actMarket.askSumDisplay | volumeFormatter(minTrade) }}
          </span>
        </div>
        <div class="Bidding-container__total-text">
          {{ $t("trade.orderBook.totalAmount") }}
        </div>
        <div class="Bidding-container__buy">
          <div
            class="graph"
            :style="{ width: `${calcVolumePerc(actMarket.bidSum)}%` }"
          ></div>
          <span>
            {{ actMarket.bidSumDisplay | volumeFormatter(minTrade) }}
          </span>
        </div>
      </div>
      <!-- 표시잔량 합계//E-->
      <div
        id="ScrollOfsset"
        :style="`height: ${biddingContainer}px; overflow-y: scroll`"
      >
        <div id="innerScrollHeight">
          <!-- 매도대기//S -->
          <div
            class="orderbook-vertical"
            style="display: flex; align-items: flex-end;"
          >
            <!-- 매도대기 리스트//S -->
            <ul class="ask-list">
              <li
                class="ask-bid-type ask"
                v-for="(sell, index) in actMarket.ask"
                :key="index"
                @click="gotoTrade(sell, 'B')"
                style="min-height: 40px; display: flex;"
              >
                <div
                  class="volume-graph"
                  style="flex-basis: 125px; font-size: 13px;"
                >
                  <template v-if="sell.volume">
                    <div class="graph-text">
                      {{ sell.volume | volumeFormatter(minTrade) }}
                    </div>
                    <div
                      class="graph"
                      :style="{ width: `${(sell.volume / askVolume) * 100}%` }"
                    ></div>
                  </template>
                </div>
                <div
                  class="price-percent"
                  :class="(sell.price - actMarket.b_close) | rbClass"
                  style="flex: 1;"
                >
                  <div class="price-percent-container" v-if="sell.price">
                    <div class="price">
                      {{ autoFormat(sell.price, actMarket) }}
                    </div>
                    <div class="arrow-icon">
                      <span class="percent-text">
                        {{ diffPercFromYd(sell.price) }}
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- 매도대기 리스트//E -->
            <div class="chart-summary">
              <div>
                <div class="today-trade">
                  <dl>
                    <dt>{{ $t("trade.info.volume") }}</dt>
                    <dd>
                      {{ formatNumber(actMarket.volume, actMarket.minTrade) }}
                      {{ $bnCode(actMarket.dealCoinCode) }}
                    </dd>
                    <dt>{{ $t("trade.info.transactionAmounts") }}</dt>
                    <dd>
                      {{
                        actMarket.acc_amount
                          | formatNumber(actMarket.baseCoinCode)
                      }}
                      {{ $bnCode(actMarket.baseCoinCode) }}
                    </dd>
                  </dl>
                </div>
                <div class="previous-trade">
                  <dl>
                    <dt>
                      {{ $t("trade.info.lastPrice") }} (
                      {{ actMarket.percStr }})
                    </dt>
                    <dd>
                      {{ autoFormat(actMarket.b_close, actMarket) }}
                      {{ $bnCode(actMarket.baseCoinCode) }}
                    </dd>
                  </dl>
                  <dl class="txt-red">
                    <dt>{{ $t("trade.info.high") }}</dt>
                    <dd>
                      {{ autoFormat(actMarket.high, actMarket) }}
                      {{ $bnCode(actMarket.baseCoinCode) }}
                    </dd>
                  </dl>
                  <dl class="txt-blue">
                    <dt>{{ $t("trade.info.low") }}</dt>
                    <dd>
                      {{ autoFormat(actMarket.low, actMarket) }}
                      {{ $bnCode(actMarket.baseCoinCode) }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <!-- 매도대기//E -->
          <div class="orderbook-vertical" style="display: flex">
            <!-- <div class="orderbook-desc bid">{{ $t("trade.orderBook.awaitingBuy") }}</div> -->
            <!-- 매수대기 리스트//S -->
            <ul class="concluded-list" style="flex-basis: 125px;">
              <li class="ask-bid-type bid">
                <div class="concluded-wrap">
                  <div class="concluded-data">
                    <div class="concluded-info">
                      <div class="concluded-price-amount">
                        <div class="concluded-price">
                          {{ $t("trade.orderBook.executionPrice") }}
                        </div>
                        <div class="concluded-amount">
                          {{ $t("trade.orderBook.executionQuantity") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="ask-bid-type bid"
                v-for="(buy, index) in bidNTrades"
                :key="index"
              >
                <div class="concluded-wrap">
                  <div class="concluded-data" style="min-height: 37px">
                    <div class="concluded-info">
                      <div
                        class="concluded-price-amount"
                        v-if="buy.lastTrade && buy.lastTrade.price"
                      >
                        <div
                          class="concluded-price"
                          :style="
                            `color:${
                              buy.lastTrade.type === 'S' ? '#eb2020' : '#1655a7'
                            }`
                          "
                        >
                          {{ formatNumber(buy.lastTrade.price, actMarket) }}
                        </div>
                        <div
                          class="concluded-amount"
                          :style="
                            `color:${
                              buy.lastTrade.type === 'S' ? '#eb2020' : '#1655a7'
                            }`
                          "
                        >
                          {{ formatNumber(buy.lastTrade.amount, minTrade) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="concluded-list" style="flex: 1">
              <li
                class="ask-bid-type bid"
                v-for="(buy, index) in bidNTrades"
                :key="index"
                style="display: flex"
              >
                <div class="concluded-wrap" style="flex: 1">
                  <div class="concluded-data">
                    <div
                      class="price-percent"
                      @click="gotoTrade(buy, 'S')"
                      :class="(buy.price - actMarket.b_close) | rbClass"
                    >
                      <div class="price-percent-container" v-if="buy.price">
                        <div class="price">{{ autoFormat(buy.price) }}</div>
                        <div class="bidding-value">
                          <span class="percent-text">
                            {{ diffPercFromYd(buy.price) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="volume-graph"
                  @click="gotoTrade(buy, 'S')"
                  style="flex-basis: 125px;font-size: 13px;"
                >
                  <template v-if="buy.volume">
                    <div class="graph-text">
                      {{ buy.volume | volumeFormatter(minTrade) }}
                    </div>
                    <div
                      class="graph"
                      :style="{ width: `${(buy.volume / bidVolume) * 100}%` }"
                    ></div>
                  </template>
                </div>
              </li>
            </ul>
            <!-- 매수대기 리스트//E -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Decimal from "decimal.js";
import Numeral from "numeral";
import DexkoSocket from "@/common/Socket";

export default {
  data() {
    return {
      priceBuy: "",
      amountBuy: "",
      percentBuy: "0",
      marketPriceBuy: false,
      priceSell: "",
      amountSell: "",
      percentSell: "0",
      marketPriceSell: false,
      coinsel: false,
      favorite: false,
      coinDefault: null,
      menuActive: false,
      actbaseCoinCode: "",
      actdealCoinCode: "",
      loadList: false,
      loadEnd: false,
      biddingContainer: 0,
    };
  },
  async mounted() {
    const { baseCoin, dealCoin } = this.$route.params;
    // this.$store.commit("SET_FOOTER", false);

    if (!this.$store.getters.marketCodeMap[`${baseCoin}-${dealCoin}`]) {
      return location.assign("/");
    }
    await this.$store.dispatch(
      "updateLastTrade",
      this.$store.getters.marketCodeMap[`${baseCoin}-${dealCoin}`].id
    );
    if (this.baseCoin && this.dealCoin) {
      this.coinDefault = this.coinList.find((market) => {
        return (
          market.baseCoinCode === this.baseCoin &&
          market.dealCoinCode === this.dealCoin
        );
      });
    } else {
      this.coinDefault = this.coinList[0];
    }
    DexkoSocket.emit("Join Room", this.coinDefault.value);

    setTimeout(() => {
      const containerOffset = document.getElementById("ScrollOfsset");
      const innerScrollHeight = document.getElementById("innerScrollHeight");

      this.biddingContainer = window.innerHeight - containerOffset.offsetTop;
      console.log(containerOffset);

      containerOffset.scrollTo({
        top: innerScrollHeight.clientHeight / 2 - this.biddingContainer / 2,
        left: 0,
        behavior: "auto",
      });
    }, 100);
  },
  // destroyed() {
  //   this.$store.commit("SET_FOOTER", true);
  // },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["marketCodeMap", "marketsByBaseCoin", "marketWithCoin"]),
    marketActive() {
      if (this.Server.version > 2) {
        return 1;
      } else {
        return 0;
      }
    },
    baseCoin() {
      return _.get(this, ["$route", "params", "baseCoin"], false);
    },
    dealCoin() {
      return _.get(this, ["$route", "params", "dealCoin"], false);
    },
    coinList() {
      const marketList = this.baseCoin
        ? this.marketsByBaseCoin[this.baseCoin]
        : this.marketCodeMap;
      return _.map(
        _.sortBy(marketList, ["baseCoinCode", "sort"]),
        (market, code) => {
          const dealCoinName = _.get(
            this.$store.state,
            ["Market", "coin", market.dealCoinCode, "name"],
            ""
          );
          return {
            ...market,
            text: `${this.$bnCode(
              market.baseCoinCode
            )} | ${dealCoinName}(${this.$bnCode(market.dealCoinCode)})`,
            value: market.id,
          };
        }
      );
    },
    actMarket() {
      const actMarket = _.get(
        this,
        ["$store", "state", "Market", "market", this.coinDefault.value],
        {}
      );
      let askSumDisplay = 0;
      let bidSumDisplay = 0;
      for (let i in actMarket.ask) {
        askSumDisplay += actMarket.ask[i].volume;
      }
      for (let i in actMarket.bid) {
        bidSumDisplay += actMarket.bid[i].volume;
      }
      return {
        ...actMarket,
        askSumDisplay: askSumDisplay,
        bidSumDisplay: bidSumDisplay,
      };
    },
    bidNTrades() {
      const lastTrades = this._.get(this, ["actMarket", "lastTrade"], []);
      let list = this._.map(this.actMarket.bid, (bid, i) => {
        return {
          ...bid,
          lastTrade: this._.get(lastTrades, [i], {}),
        };
      });
      return list;
    },
    minTrade() {
      return _.get(this, ["actMarket", "minTrade"], 0.00000001);
    },
    callUnit() {
      return _.get(this, ["actMarket", "callUnit"], 0.00000001);
    },
    markets() {
      const baseCoins = ["KRW", "USDT", "BTC"];

      return _.zipObject(
        baseCoins,
        _.map(baseCoins, (coinCode) => {
          const markets = this.marketsByBaseCoin[coinCode] || [];
          if (!markets) return;
          const returnMarkets = markets
            .filter((market) => market.onViewEnable === "Y")
            .map((market) => {
              return {
                ...this.marketWithCoin(market.id),
                img: `//static.flybit.com/static/img/mobile/coin_${market.dealCoinCode}.png`,
              };
            });
          return _.sortBy(returnMarkets, ["sort"]);
        })
      );
    },
    // 전체 총 수량
    totalVolume() {
      return Numeral(this.actMarket.askSum)
        .add(this.actMarket.bidSum)
        .value();
    },
    // 매도 row
    asks() {
      return _.get(this.actMarket, ["ask"], []);
    },
    // 매수 row
    bids() {
      return _.get(this.actMarket, ["bid"], []);
    },
    // 매도 총 수량
    askVolume() {
      return _.reduce(
        this.asks,
        (p, n, i) => {
          const pv = _.get(p, "volume", p);
          const nv = _.get(n, "volume", n);
          return Numeral(pv)
            .add(nv)
            .value();
        },
        0
      );
    },
    // 매수 총 수량
    bidVolume() {
      return _.reduce(
        this.bids,
        (p, n, i) => {
          const pv = _.get(p, "volume", p);
          const nv = _.get(n, "volume", n);
          return Numeral(pv)
            .add(nv)
            .value();
        },
        0
      );
    },
  },
  methods: {
    // 해당 거래량이 총 거래량의 몇 %인지 연산
    calcVolumePerc(volume) {
      if (!volume || !this.totalVolume) {
        return 0;
      }
      return Decimal(volume)
        .div(this.totalVolume)
        .mul(100)
        .toNumber();
    },
    autoFormat(n) {
      if (this.actMarket && this.actMarket.callUnit < 1) {
        return this.$options.filters.formatNumber(
          n,
          Math.ceil(Math.abs(Math.log10(this.actMarket.callUnit)))
        );
      } else {
        return this.$options.filters.formatNumber(n);
      }
    },
    noti() {
      this.$vs.notify({
        title: "알림",
        text: "서비스 준비 중 입니다.",
        position: "top-right",
        color: "danger",
      });
    },
    // 전일가 대비 변동량(%)
    diffPercFromYd(current) {
      if (current === this.actMarket.b_close) {
        return "0.00%";
      }
      const result =
        Decimal(current - this.actMarket.b_close)
          .div(this.actMarket.b_close || 1)
          .abs()
          .toNumber() || 0;
      return Numeral(result).format("0,0.00%");
    },
    gotoTrade(order, tradeTargetMode) {
      const { dealCoinCode, baseCoinCode } = this.actMarket;
      this.$router.push({
        name: "TradeWithCode",
        params: {
          baseCoin: baseCoinCode,
          dealCoin: dealCoinCode,
          price: order.price,
          tradeTargetMode,
        },
      });
    },
  },
  watch: {
    "$route.params": {
      immediate: true,
      handler(to) {
        const marketCode = `${to.baseCoin}-${to.dealCoin}`;
        const { baseCoin, dealCoin } = this.$route.params;
        if (this.baseCoin && this.dealCoin) {
          this.coinDefault = this.coinList.find((market) => {
            return (
              market.baseCoinCode === this.baseCoin &&
              market.dealCoinCode === this.dealCoin
            );
          });
        } else {
          this.coinDefault = this.coinList[0];
        }
      },
    },
  },
  destroyed() {
    DexkoSocket.emit("Leave Room", this.coinDefault.value);
  },
  name: "Bidding",
};
</script>

<style lang="scss" scoped>
.trade-container {
  display: table;
  width: 100%;
  box-sizing: border-box;
}
.orderbook {
  display: table-cell;
  position: relative;
  width: 38.28%;
  box-shadow: 2px 2px 5px 1px rgba(14, 80, 173, 0.22);
  > div {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: scroll;
    border-radius: 3px;
  }
  .line {
    display: none;
    position: absolute;
    top: 50.5vh;
    left: 0;
  }
}
.order-box {
  display: table-cell;
  width: 59.57%;
  padding-left: 2.14%;
  > div {
    margin-top: 9px;
    box-shadow: 2px 2px 5px 1px rgba(14, 80, 173, 0.22);
    &:first-child {
      margin-top: 0;
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.market-item-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chart-summary {
  flex-basis: 125px;
}

.Bidding-container {
  &__total-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fafafa;
    color: #333;
  }

  &__sell,
  &__buy {
    flex-basis: 125px;
    min-height: 40px;
    position: relative;

    .graph {
      height: 25px;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }

    span {
      position: absolute;
      font-size: 14px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  &__sell {
    .graph {
      background: #ccdbeb;
      right: 0;
      z-index: 1;
    }

    span {
      right: 10px;
      z-index: 2;
    }
  }

  &__buy {
    .graph {
      background: #f6cccc;
      left: 0;
      z-index: 1;
    }

    span {
      left: 10px;
      z-index: 2;
    }
  }

  &__total-text {
    flex: 1;
    min-height: 40px;
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bidding-value {
    display: flex;
    align-items: center;
    i {
      font-size: 18px;
    }

    span {
      line-height: 18px;
    }
  }

  .price-percent-container {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    padding: 0 8px;

    .price {
      text-align: left;
      font-size: 13px;
      margin-right: 5px;
      font-weight: bold;
    }
  }
}
</style>
